import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    column: {
      flex: 1,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      border: `1px solid ${colors.color39}`,
      borderRadius: '4px',
      backgroundColor: colors.color5,
    },
    columnHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px 16px',
      backgroundColor: `${colors.color25}50`,
      borderBottom: `1px solid ${colors.color39}`,
      flexShrink: 0,
    },
    columnTitle: {
      fontSize: '16px',
      fontWeight: '500',
      color: colors.color13,
    },
    userListContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflowY: 'auto',
      padding: '0 16px 12px 16px',
      gap: '8px',
      minHeight: 0,
    },
    searchWrapper: {
      position: 'sticky',
      top: 0,
      zIndex: 2,
      backgroundColor: colors.color5,
      paddingTop: '12px',
    },
    selectAllRow: {
      display: 'flex',
      alignItems: 'center',
      padding: '6px 6px',
      gap: '6px',
      cursor: 'pointer',
      border: `1px solid ${colors.color39}`,
      borderRadius: '4px',
    },
    selectAllText: {
      fontSize: '16px',
      color: colors.color13,
    },
    userItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 8px 8px 6px',
      gap: '6px',
      borderRadius: '4px',
      border: `1px solid ${colors.color39}`,
      cursor: 'pointer',
      backgroundColor: colors.color5,
      '&:hover': {
        backgroundColor: colors.ashBlue,
      },
    },
    userItemInfo: {
      flex: 1,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
    },
    userItemName: {
      fontSize: '14px',
      fontWeight: '500',
      color: colors.color13,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    userItemDetail: {
      fontSize: '12px',
      color: colors.color10,
      marginTop: '2px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    noData: {
      fontSize: '14px',
      color: colors.color10,
      textAlign: 'center',
      padding: '24px 0',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      py: 4,
    },
    errorText: {
      fontSize: '14px',
      color: colors.color19,
      textAlign: 'center',
      padding: '24px 0',
    },
  }
}
